<template>
    <md-card>
        <md-card-content>
            <md-table
                    :value="queriedData"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="paginated-table table-striped table-hover">
                <md-table-toolbar>
                    <md-field>
                        <label for="pages">Per page</label>
                        <md-select v-model="pagination.perPage" name="pages">
                            <md-option
                                    v-for="item in pagination.perPageOptions"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                            >
                                {{ item }}
                            </md-option>
                        </md-select>
                    </md-field>

                    <md-field>
                        <md-input
                                type="search"
                                class="mb-3"
                                clearable
                                style="width: 200px"
                                placeholder="Search records"
                                v-model="searchQuery"
                                @input="searchOnTables">
                        </md-input>
                    </md-field>
                </md-table-toolbar>

                <md-table-empty-state
                        md-label="No permission found"
                        :md-description="`No permission found for this '${search}' query. Try a different search term or attach new permission.`">
                    <md-button class="md-primary md-raised"
                               @click="$emit('addPermissionToUser', user.id)">
                        Attach Permission
                    </md-button>
                </md-table-empty-state>

                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="Names" md-sort-by="name">{{item.display_name}}</md-table-cell>
                    <md-table-cell md-label="Description" md-sort-by="name">{{item.description}}</md-table-cell>
                    <md-table-cell md-label="Roles" md-sort-by="created_at">{{item.roles_name}}</md-table-cell>
                    <md-table-cell md-label="Actions">
                        <md-button
                                class="md-just-icon md-info md-simple"
                                @click.native="handleLike(item)">
                            <md-icon>favorite</md-icon>
                        </md-button>
                        <md-button
                                class="md-just-icon md-warning md-simple"
                                @click.native="handleEdit(item)">
                            <md-icon>dvr</md-icon>
                        </md-button>
                        <md-button
                                class="md-just-icon md-danger md-simple"
                                @click="handleDelete(item)">
                            <md-icon>delete</md-icon>
                        </md-button>
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
            <div class="">
                <p class="card-category">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                </p>
            </div>
            <pagination
                    class="pagination-no-border pagination-success"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
            >
            </pagination>
        </md-card-actions>
    </md-card>
</template>

<script>
import { Pagination } from '@/components';
import Swal from 'sweetalert2';
import Fuse from 'fuse.js';
const toLower = text => {
    return text.toString().toLowerCase();
};
const searchByName = (items, term) => {
    if (term) {
        return items.filter(item => toLower(item.name).includes(toLower(term)));
    }
    return items;
};
export default {
    name: 'UserPermissionsTable',
    components: {
        Pagination
    },
    computed: {
        /** *
             * Returns a page from the searched data or the whole data. Search is performed in the watch section below
             */
        queriedData () {
            let result = this.searchedPermissions;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to () {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total () {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.searchedPermissions.length;
        }
    },
    props: {
        tableData: {
            type: Array
        },
        user: {
            type: Object,
            default: () => {
            }
        },
        type:{
            type:String,
            default:'user'
        }
    },
    data () {
        return {
            currentSort: 'name',
            currentSortOrder: 'asc',
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            },
            footerTable: ['Name', 'Email'],
            searchQuery: '',
            search: null,
            propsToSearch: ['name', 'email'],
            searchedData: [],
            searchedPermissions:[],
            fuseSearch: null
        };
    },
    created () {
        this.searchedPermissions = this.tableData;
    },
    methods: {
        searchOnTables (searchKey) {
            this.searchedPermissions = searchByName(this.tableData, searchKey);
        },
        customSort (value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort;
                if (this.currentSortOrder === 'desc') {
                    return a[sortBy].localeCompare(b[sortBy]);
                }
                return b[sortBy].localeCompare(a[sortBy]);
            });
        },
        handleLike (item) {
            Swal.fire({
                title: `You liked ${item.name}`,
                buttonsStyling: false,
                type: 'success',
                confirmButtonClass: 'md-button md-success'
            });
        },
        handleEdit (item) {
            Swal.fire({
                title: `You want to edit ${item.name}`,
                buttonsStyling: false,
                confirmButtonClass: 'md-button md-info'
            });
        },
        handleDelete (item) {
            Swal.fire({
                title: 'Are you sure?',
                text: `Remove permission '${item.name}' from ${this.type} ${this.user.name}`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-success btn-fill',
                cancelButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: 'Yes, delete it!',
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.$emit('removePermission', item);
                    Swal.fire({
                        title: 'Deleted!',
                        text: `You deleted permission '${item.name}'`,
                        type: 'success',
                        confirmButtonClass: 'md-button md-success btn-fill',
                        buttonsStyling: false
                    });
                }
            });
        },
        deleteRow (item) {
            let indexToDelete = this.tableData.findIndex(
                tableRow => tableRow.id === item.id
            );
            if (indexToDelete >= 0) {
                console.log('call in main');
                // this.tableData.splice(indexToDelete, 1);
            }
        }
    },
    mounted () {
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: ['name', 'email'],
            threshold: 0.3
        });
    },
    watch: {
        /**
             * Searches through the table data by a given query.
             * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
             * @param value of the query
             */
        searchQuery (value) {
            let result = this.tableData;
            if (value !== '') {
                result = this.fuseSearch.search(this.searchQuery);
            }
            this.searchedData = result;
        },
        tableData () {
            this.searchedPermissions =  this.tableData;
        }
    }
};
</script>

<style scoped>

</style>
